import { Component, OnInit } from '@angular/core';
import { DialogService } from 'primeng/dynamicdialog';
import { ssApiService } from 'app/services/ss-api.service';
import { KeyValuePairArray } from 'app/models/KeyValuePair';
import { Router, ActivatedRoute } from '@angular/router';
import { AddCreditCardDialogComponent } from '../add-credit-card/add-credit-card-dialog.component';
import { IBaseResponse } from 'app/models/comm-http/responses/BaseResponse';
import { CompleteOrderDialogComponent } from '../complete-order/complete-order-dialog.component';
import { IErrorEventArgs } from 'app/models/event-args/global-error.event.args';
import { xToastr, ToastrTypes } from 'app/shared/Toastr';
import {DynamicDialogRef} from 'primeng/dynamicdialog';
import {DynamicDialogConfig} from 'primeng/dynamicdialog';

export interface ILoginDialogModel {
    IsWelcomeBack?: boolean;
    ProductID?: number;
    BillingCycle?: number;
    HasYard?: boolean;
}

export enum FormTypes {
    SigninForm = 0,
    SigninFormTest = 1,
    TwoFactorChoiceForm = 2,
    TwoFactorCodeForm = 3,
    ForgotPasswordForm = 4,
    Redirect = 5,
    Locked = 6
}

@Component({
  selector: 'login-dialog',
  styleUrls: ['./auth-login-dialog.component.scss'],
  templateUrl: './auth-login-dialog.component.html',
  providers: [DialogService]
})
export class LoginDialogComponent implements ILoginDialogModel, OnInit {

    TwoFactorOptions: KeyValuePairArray<string, string>;
    IsBusy: boolean = false;

    IsWelcomeBack: boolean = false;
    ProductID: number;
    BillingCycle: number;
    HasYard: boolean;

    // DATA SUBSCRIPTION VARIABLES
    paramsSubscribe: any;
    routeParams: object;

    SelectedForm: FormTypes = FormTypes.SigninForm;

    result: any;

    constructor(
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        private router: Router, public dialogService: DialogService, private route: ActivatedRoute
    ) {
        // subscribe and add to list
        this.ShowForm(FormTypes.SigninForm);
        this.paramsSubscribe = this.route.params.subscribe(params => this.routeParams = params);
    }

    ngOnInit() {
        this.IsWelcomeBack = this.config.data.IsWelcomeBack;
        this.ProductID = this.config.data.ProductID;
        this.BillingCycle = this.config.data.BillingCycle;
        this.HasYard = this.config.data.HasYard;

        if (this.routeParams['welcomeBack'] != undefined) {
            this.IsWelcomeBack = true;
        } else if (this.route.snapshot.queryParams['forgotPassword'] != undefined) {
            this.SelectedForm = FormTypes.ForgotPasswordForm;
        } else if (this.routeParams['token'] != undefined) {
            this.dialogService.open(AddCreditCardDialogComponent, {});
        }
    }

    close() {
        this.ref.close();
    }

    ShowForm(form: FormTypes) {

        this.SelectedForm = form;
    }

    UseDifferentEmail() {
        this.result = true;
        this.close();
    }


    onBusyChanged(isBusy: boolean) {
        this.IsBusy = isBusy;
    }

    onAuthenticated(ev: IBaseResponse<any>) {
        this.ShowForm(FormTypes.Redirect);

        if (this.ProductID && this.BillingCycle) {
            localStorage.setItem('cartProductID', this.ProductID.toString());
            localStorage.setItem('cartBillingCycle', this.BillingCycle.toString());
            localStorage.setItem('cartHasYard', this.HasYard.toString());
        }

        setTimeout(() => {

            // load redirect
            if (ev.Redirect != null)
                this.router.navigate([ev.Redirect]);
            else
                this.router.navigate(['account/product-memberships']);

            this.close();

        }, 2500);

    }

    onTwoFactorRequired(twoFactorOptions: KeyValuePairArray<string, string>) {
        this.TwoFactorOptions = twoFactorOptions;
        this.ShowForm(FormTypes.TwoFactorChoiceForm);
    }

    onTwoFactorCodeSent() {
        this.ShowForm(FormTypes.TwoFactorCodeForm);
    }

    onForgotPassword() {
        this.ShowForm(FormTypes.ForgotPasswordForm);
    }

    onForgotPasswordCancel() {
        this.ShowForm(FormTypes.SigninForm);
    }

    onLocked() {
        this.ShowForm(FormTypes.Locked);
    }

    onUnfinishedOrder(ufoid: string) {

        // var dialog = this.dialogService.addDialog(CompleteOrderDialogComponent, {
        //     UFOID: ufoid
        // })

    }

    onError(ev: IErrorEventArgs) {
        xToastr.ShowToast(ToastrTypes.Error, ev.FriendlyErrorTitle, ev.FriendlyErrorMessage);

        if (this.SelectedForm == FormTypes.TwoFactorChoiceForm)
            this.ShowForm(FormTypes.SigninForm);
    }

    onCancel() {

        if (this.SelectedForm == FormTypes.TwoFactorChoiceForm)
            this.ShowForm(FormTypes.SigninForm);
        else if (this.SelectedForm == FormTypes.TwoFactorCodeForm)
            this.ShowForm(FormTypes.TwoFactorChoiceForm);
        else
            this.ShowForm(FormTypes.SigninForm);
    }

}
